<template>
    <div class="Time">
        <div class="container">
            <div class="box-header">
                <h3 style="color:black;">
                    <i class="el-icon-date" style="color:blue;margin-right: 8px;"></i>本周忙碌时间设置
                </h3>
                <div class="header-modal-close">
                    <i class="el-icon-close" @click.prevent="close"></i>
                </div>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center; padding: 15px 10px 0 10px;">
            </div>
            <div class="status-indicator">
                <div class="status-left">
                    <div class="status-item">
                        <div class="status-color status-free"></div>
                        <span style="color:#67c23a">空闲: {{ freeCount }} 个时段</span>
                    </div>
                    <div class="status-item">
                        <div class="status-color status-busy"></div>
                        <span style="color:#f56c6c">忙碌: {{ busyCount }} 个时段</span>
                    </div>
                    <div class="status-item">
                        <div style="margin-left: 10px;">
                            <el-checkbox v-model="busySaturday" @change="busySaturdayChange">周六忙碌</el-checkbox>
                        </div>
                        <div style="margin-left: 10px;">
                            <el-checkbox v-model="busySunday" @change="busySundayChange">周天忙碌</el-checkbox>
                        </div>
                    </div>
                </div>
                <div class="status-right">
                    <el-button type="primary" @click="saveDate" style="width: 120px;"><i
                            class="el-icon-document-copy"></i>
                        保存日程</el-button>
                </div>
            </div>
            <el-table :data="tableData" height="480" border style="width: 100%; margin:20px auto;"
                class="full-cell-table">
                <el-table-column prop="time" label="时段" width="120" align="center">
                </el-table-column>
                <el-table-column v-for="day in days" :key="day.key" :label="day.name" align="center">
                    <template slot-scope="scope">
                        <div :class="['full-cell', scope.row[day.key] ? 'busy' : 'free']"
                            @click="toggleStatus(scope.$index, day.key)">
                            {{ scope.row[day.key] ? '忙碌' : '空闲' }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { setTime, getTime } from "@/request/api";
export default {
    data() {
        return {
            busySaturday: false,
            busySunday: false,
            username: '',
            days: [
                { key: 'monday', name: '周一' },
                { key: 'tuesday', name: '周二' },
                { key: 'wednesday', name: '周三' },
                { key: 'thursday', name: '周四' },
                { key: 'friday', name: '周五' },
                { key: 'saturday', name: '周六' },
                { key: 'sunday', name: '周日' },
                { key: 'nextMonday', name: '下周一' },
            ],
            tableData: [
                { time: '09:00-09:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '09:30-10:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '10:00-10:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '10:30-11:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '11:00-11:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '11:30-12:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                //{ time: '12:00-12:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false,nextMonday: false },
                //{ time: '12:30-13:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false,nextMonday: false },
                { time: '13:00-13:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '13:30-14:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '14:00-14:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '14:30-15:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '15:00-15:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '15:30-16:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '16:00-16:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '16:30-17:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '17:00-17:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '17:30-18:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '18:00-18:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '18:30-19:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '19:00-19:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '19:30-20:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                // { time: '20:00-20:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false,nextMonday: false },
                // { time: '20:30-21:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false,nextMonday: false },
            ]
        }
    },
    computed: {
        busyCount() {
            let count = 0;
            this.tableData.forEach(row => {
                this.days.forEach(day => {
                    if (row[day.key]) count++;
                });
            });
            return count;
        },
        freeCount() {
            let count = 0;
            this.tableData.forEach(row => {
                this.days.forEach(day => {
                    if (!row[day.key]) count++;
                });
            });
            return count;
        }
    },
    methods: {
        async getTimeTable() {
            var { data: res } = await getTime({ username: this.username });
            if (res.code === 200) {
                this.formatTimeTable(res);
            } else {
                this.$message.error('获取失败');
            }
        },
        formatTimeTable(rawData) {
            // 1. 生成符合要求的时间段列表（09:00-20:00，每30分钟一段，排除12:00-13:00）
            const timeSlots = this.generateTimeSlots();

            // 2. 处理后端返回的星期数据，key统一转成小写（对应目标格式的字段）
            const weekData = {
                monday: rawData.data.Monday.split(',').map(item => item === '1'),
                tuesday: rawData.data.Tuesday.split(',').map(item => item === '1'),
                wednesday: rawData.data.Wednesday.split(',').map(item => item === '1'),
                thursday: rawData.data.Thursday.split(',').map(item => item === '1'),
                friday: rawData.data.Friday.split(',').map(item => item === '1'),
                saturday: rawData.data.Saturday.split(',').map(item => item === '1'),
                sunday: rawData.data.Sunday.split(',').map(item => item === '1'),
                nextMonday: rawData.data.nextMonday.split(',').map(item => item === '1')
            };

            // 3. 组装最终的时间表格数组
            this.tableData = timeSlots.map((time, index) => {
                return {
                    time: time,
                    monday: weekData.monday[index] || false,
                    tuesday: weekData.tuesday[index] || false,
                    wednesday: weekData.wednesday[index] || false,
                    thursday: weekData.thursday[index] || false,
                    friday: weekData.friday[index] || false,
                    saturday: weekData.saturday[index] || false,
                    sunday: weekData.sunday[index] || false,
                    nextMonday: weekData.nextMonday[index] || false
                };
            });
            this.busySaturday = this.checkAllSaturdayBusy('saturday');
            this.busySunday = this.checkAllSaturdayBusy('sunday');
        },
        checkAllSaturdayBusy(item) {
            // 使用循环方式检查是否所有周六都忙碌
            for (let i = 0; i < this.tableData.length; i++) {
                if (this.tableData[i][item] !== true) {
                    return false; // 如果有任何一个周六不是true，则返回false
                }
            }
            return true; // 所有周六都是true时返回true
        },
        generateTimeSlots() {
            const slots = [];
            let startHour = 9;
            let startMinute = 0;

            // 结束时间：20:00
            while (startHour < 20) {
                // 计算结束时间
                let endHour = startHour;
                let endMinute = startMinute + 30;

                // 分钟进位处理
                if (endMinute === 60) {
                    endHour += 1;
                    endMinute = 0;
                }

                // 格式化时间字符串（补零）
                const startStr = `${startHour.toString().padStart(2, '0')}:${startMinute.toString().padStart(2, '0')}`;
                const endStr = `${endHour.toString().padStart(2, '0')}:${endMinute.toString().padStart(2, '0')}`;
                const timeSlot = `${startStr}-${endStr}`;

                // 排除12:00-13:00（包含12:00-12:30和12:30-13:00两个时段）
                if (!(timeSlot === '12:00-12:30' || timeSlot === '12:30-13:00')) {
                    slots.push(timeSlot);
                }

                // 更新下一个时段的开始时间
                startMinute = endMinute;
                if (startMinute === 0) {
                    startHour += 1;
                }
            }
            return slots;
        },
        busySaturdayChange() {
            if (this.busySaturday) {
                this.tableData.forEach(row => {
                    row.saturday = true;
                });
            } else {
                this.tableData.forEach(row => {
                    row.saturday = false;
                });
            }
        },
        busySundayChange() {
            if (this.busySunday) {
                this.tableData.forEach(row => {
                    row.sunday = true;
                });
            } else {
                this.tableData.forEach(row => {
                    row.sunday = false;
                });
            }
        },
        toggleStatus(rowIndex, dayKey) {
            this.tableData[rowIndex][dayKey] = !this.tableData[rowIndex][dayKey];
        },
        async saveDate() {
            var { data: res } = await setTime({ timeTable: this.tableData, username: this.username });
            if (res.code === 200) {
                console.log(res);
                this.$message.success('保存成功');
            } else {
                this.$message.error('保存失败');
            }
            console.log(this.tableData);
        },
        close() {
            this.$emit('TimeClose');
        },
    },
    created() {
        if (sessionStorage.getItem("LoginInfo")) {
            this.username = JSON.parse(sessionStorage.getItem("LoginInfo")).username;
        }

        this.getTimeTable();
    }
}
</script>

<style lang="scss" scoped>
* {
    box-sizing: border-box;
}

.Time {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.9);
    overflow: hidden;
}

/* 容器样式 */
.container {
    position: relative;
    padding: 20px;
    width: 90%;
    max-width: 1200px;
    margin: 20px auto;
    background-color: white;
    /* 白色时间块 */
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.box-header {
    position: relative;

    .header-modal-close {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 1px;
        width: 40px;
        height: 40px;
        font-size: 24px;
        font-weight: bold;
        align-items: center;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        justify-content: center;
        color: black;
    }

    .header-modal-close:hover {
        background-color: rgba(0, 119, 255, 0.06);
        border-radius: 20px;
    }
}

/* 表格单元格样式 */
.full-cell {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.3s;
    font-weight: 500;
}

.full-cell-table .el-table__body tr td {
    padding: 0 !important;
    position: relative;
    height: 50px;
}

/* 为表格第一行添加粉色背景 */
.full-cell-table .el-table__header-wrapper .has-gutter tr th {
    background-color: rgb(243 244 246);
    color: rgb(55 65 81);
    font-weight: bold;
}


.full-cell-table .el-table__body tr:hover td {
    background-color: transparent;
}

/* 状态颜色 */
.busy {
    background-color: rgb(239 68 68 / 0.1);
}

.free {
    /* background-color: #67c23a; */
}

.full-cell:hover {
    transform: scale(0.95);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 页头样式 */
.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #ebeef5;
}

.page-title {
    color: #303133;
    margin: 0;
}

/* 状态指示器 */
.status-indicator {
    display: flex;
    gap: 20px;
    margin-top: 10px;
    justify-content: space-between;
    align-items: center;

    .status-item:nth-child(1) {
        margin-right: 8px;
    }

    .status-left {
        display: flex;
        align-items: center;
    }
}

.status-item {
    display: flex;
    align-items: center;
    font-size: 14px;
}

.status-color {
    width: 15px;
    height: 15px;
    border-radius: 4px;
    margin-right: 4px;
}

.status-busy {
    background-color: #f56c6c;
}

.status-free {
    background-color: #67c23a;
}
</style>